import React, { useRef, useLayoutEffect, useState, useEffect } from 'react';
import {  Grid } from '@mui/material';
import useWindowsDimension from 'functions/useWindowsDimension';
import { DustinImportProduct } from './DustinImportProduct';



export const Test = () => {
  const { width, height } = useWindowsDimension();

  
  return (
  <>
  <DustinImportProduct onSave={(p) => console.log(p)} />
  </>
  );
};